export default {
  'deliveryOrReturnOfMaterials.create.confirmDelivery': 'Confirm Delivery',
  'deliveryOrReturnOfMaterials.create.confirmedDevolution':
    'Confirmed Devolution',
  'deliveryOrReturnOfMaterials.create.returnMaterial': 'Returner Material',
  'deliveryOrReturnOfMaterials.create.deliverMaterial': 'Deliver material',
  'deliveryOrReturnOfMaterials.columns.table.company': 'Company',
  'deliveryOrReturnOfMaterials.columns.table.deliveredOrReturnedBy':
    'Delivered/Returned by:',
  'deliveryOrReturnOfMaterials.columns.table.receivedBy': 'Received by:',
  'deliveryOrReturnOfMaterials.columns.table.date': 'Date',
  'deliveryOrReturnOfMaterials.columns.table.deliveryOrReturn':
    'Delivery/Return',

  'deliveryOrReturnOfMaterials.deliverMaterial.form.deliveryData':
    'Delivery Data',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.company': 'Company',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.deliveredBy':
    'Delivered By',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.receivedBy': 'Received By',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.button.includeParts':
    'Include Parts',
  'deliveryOrReturnOfMaterials.deliverMaterial.form.button.includeConsumables':
    'Include Consumables',

  'deliveryOrReturnOfMaterials.deliverMaterial.TitleTable.itemsToDeliver':
    'Items to Deliver',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.workOrder': 'O.S',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.description':
    'Description',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.manufacturerCode':
    'Manufacturer Code',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.type': 'Type',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.qtyRequested':
    'Qty. Requested',
  'deliveryOrReturnOfMaterials.deliverMaterial.table.column.qtyDelivered':
    'Qty. Delivered',

  'deliveryOrReturnOfMaterials.returnMaterial.form.dateOfReturn':
    'Devolution Date',
  'deliveryOrReturnOfMaterials.returnMaterial.form.company': 'Company',
  'deliveryOrReturnOfMaterials.returnMaterial.form.returnedBy': 'Returned by:',
  'deliveryOrReturnOfMaterials.returnMaterial.form.receivedBy': 'Received by:',
  'deliveryOrReturnOfMaterials.returnMaterial.form.display': 'Display',
  'deliveryOrReturnOfMaterials.returnMaterial.form.display.part': 'Parts Only',
  'deliveryOrReturnOfMaterials.returnMaterial.form.display.consumable':
    'Consumables Only',

  'deliveryOrReturnOfMaterials.returnMaterial.table.column.workOrder': 'B.D',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.description':
    'Description',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.licensePlate':
    'License Plate',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.delivery':
    'Delivery',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.manufacturer':
    'Mnufacturer',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.qtyReturned':
    'Qty. returned',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.qtyDelivered':
    'Qty. Delivered',
  'deliveryOrReturnOfMaterials.returnMaterial.table.column.qtyGiveBack':
    'Qty. GiveBack',
};
